export default "__VITE_ASSET__81ce23c7__"